import { render, staticRenderFns } from "./GroupRoleCreate.vue?vue&type=template&id=6ec36722&"
import script from "./GroupRoleCreate.vue?vue&type=script&lang=js&"
export * from "./GroupRoleCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports